import React from "react";
import { MarkdownPage } from "./MarkdownPage";

export const AppsInfoPage = () => (
  <MarkdownPage file="AppsInfo.md" />
);
